var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { IPermissions } from "@/types/keycloak";
var AdminOperationMap = {
    ListTrusteeBoards: IPermissions.TRUSTEE_CEREMONY,
    ReportTrusteeBoard: IPermissions.TRUSTEE_CEREMONY,
    ConfirmKeyCustody: IPermissions.TRUSTEE_CEREMONY,
    AuthorizeTallyCustody: IPermissions.TRUSTEE_CEREMONY,
    GetCustodyRequest: IPermissions.TRUSTEE_CEREMONY,
    // area
    sequent_backend_area: IPermissions.AREA_READ,
    sequent_backend_areas: IPermissions.AREA_READ,
    insert_sequent_backend_area: IPermissions.AREA_WRITE,
    insert_sequent_backend_areas: IPermissions.AREA_WRITE,
    update_sequent_backend_area: IPermissions.AREA_WRITE,
    update_sequent_backend_areas: IPermissions.AREA_WRITE,
    delete_sequent_backend_area: IPermissions.AREA_WRITE,
    delete_sequent_backend_areas: IPermissions.AREA_WRITE,
    // area_contest
    sequent_backend_area_contest: IPermissions.AREA_READ,
    sequent_backend_area_contests: IPermissions.AREA_READ,
    insert_sequent_backend_area_contest: IPermissions.AREA_WRITE,
    insert_sequent_backend_area_contests: IPermissions.AREA_WRITE,
    update_sequent_backend_area_contest: IPermissions.AREA_WRITE,
    update_sequent_backend_area_contests: IPermissions.AREA_WRITE,
    delete_sequent_backend_area_contest: IPermissions.AREA_WRITE,
    delete_sequent_backend_area_contests: IPermissions.AREA_WRITE,
    // ballot_publication
    sequent_backend_ballot_publication: IPermissions.PUBLISH_READ,
    sequent_backend_ballot_publications: IPermissions.PUBLISH_READ,
    insert_sequent_backend_ballot_publication: IPermissions.PUBLISH_WRITE,
    insert_sequent_backend_ballot_publications: IPermissions.PUBLISH_WRITE,
    update_sequent_backend_ballot_publication: IPermissions.PUBLISH_WRITE,
    update_sequent_backend_ballot_publications: IPermissions.PUBLISH_WRITE,
    delete_sequent_backend_ballot_publication: IPermissions.PUBLISH_WRITE,
    delete_sequent_backend_ballot_publications: IPermissions.PUBLISH_WRITE,
    // tally_results_publication
    sequent_backend_tally_results_publication: IPermissions.PUBLISH_RESULTS_READ,
    sequent_backend_tally_results_publications: IPermissions.PUBLISH_RESULTS_READ,
    // ballot_style
    sequent_backend_ballot_style: IPermissions.PUBLISH_READ,
    sequent_backend_ballot_styles: IPermissions.PUBLISH_READ,
    // candidate
    sequent_backend_candidate: IPermissions.CANDIDATE_READ,
    sequent_backend_candidates: IPermissions.CANDIDATE_READ,
    insert_sequent_backend_candidate: IPermissions.CANDIDATE_CREATE,
    insert_sequent_backend_candidates: IPermissions.CANDIDATE_CREATE,
    update_sequent_backend_candidate: IPermissions.CANDIDATE_WRITE,
    update_sequent_backend_candidates: IPermissions.CANDIDATE_WRITE,
    delete_sequent_backend_candidate: IPermissions.CANDIDATE_DELETE,
    delete_sequent_backend_candidates: IPermissions.CANDIDATE_DELETE,
    // certificate_authority
    sequent_backend_certificate_authority: IPermissions.CA_READ,
    sequent_backend_certificate_authorities: IPermissions.CA_READ,
    delete_sequent_backend_certificate_authority_by_pk: IPermissions.CA_WRITE,
    delete_sequent_backend_certificate_authorities: IPermissions.CA_WRITE,
    // template
    sequent_backend_template: IPermissions.template_READ,
    sequent_backend_templates: IPermissions.template_READ,
    insert_sequent_backend_template: IPermissions.template_WRITE,
    insert_sequent_backend_templates: IPermissions.template_WRITE,
    update_sequent_backend_template: IPermissions.template_WRITE,
    update_sequent_backend_templates: IPermissions.template_WRITE,
    delete_sequent_backend_template: IPermissions.template_WRITE,
    delete_sequent_backend_templates: IPermissions.template_WRITE,
    // contest
    sequent_backend_contest: IPermissions.CONTEST_READ,
    sequent_backend_contests: IPermissions.CONTEST_READ,
    insert_sequent_backend_contest: IPermissions.CONTEST_CREATE,
    insert_sequent_backend_contests: IPermissions.CONTEST_CREATE,
    update_sequent_backend_contest: IPermissions.CONTEST_WRITE,
    update_sequent_backend_contests: IPermissions.CONTEST_WRITE,
    delete_sequent_backend_contest: IPermissions.CONTEST_DELETE,
    delete_sequent_backend_contests: IPermissions.CONTEST_DELETE,
    // document
    sequent_backend_document: IPermissions.DOCUMENT_READ,
    sequent_backend_documents: IPermissions.DOCUMENT_READ,
    insert_sequent_backend_document: IPermissions.DOCUMENT_WRITE,
    insert_sequent_backend_documents: IPermissions.DOCUMENT_WRITE,
    update_sequent_backend_document: IPermissions.DOCUMENT_WRITE,
    update_sequent_backend_documents: IPermissions.DOCUMENT_WRITE,
    delete_sequent_backend_document: IPermissions.DOCUMENT_WRITE,
    delete_sequent_backend_documents: IPermissions.DOCUMENT_WRITE,
    // election
    sequent_backend_election: IPermissions.ELECTION_READ,
    sequent_backend_elections: IPermissions.ELECTION_READ,
    insert_sequent_backend_election: IPermissions.ELECTION_CREATE,
    insert_sequent_backend_elections: IPermissions.ELECTION_CREATE,
    update_sequent_backend_election: IPermissions.ELECTION_WRITE,
    update_sequent_backend_elections: IPermissions.ELECTION_WRITE,
    delete_sequent_backend_election: IPermissions.ELECTION_DELETE,
    delete_sequent_backend_elections: IPermissions.ELECTION_DELETE,
    // election_type
    sequent_backend_election_type: IPermissions.ELECTION_TYPE_READ,
    sequent_backend_elections_type: IPermissions.ELECTION_TYPE_READ,
    insert_sequent_backend_election_type: IPermissions.ELECTION_TYPE_WRITE,
    insert_sequent_backend_election_types: IPermissions.ELECTION_TYPE_WRITE,
    update_sequent_backend_election_type: IPermissions.ELECTION_TYPE_WRITE,
    update_sequent_backend_election_types: IPermissions.ELECTION_TYPE_WRITE,
    delete_sequent_backend_election_type: IPermissions.ELECTION_TYPE_WRITE,
    delete_sequent_backend_election_types: IPermissions.ELECTION_TYPE_WRITE,
    // election_event
    sequent_backend_election_event: IPermissions.ELECTION_EVENT_READ,
    sequent_backend_election_events: IPermissions.ELECTION_EVENT_READ,
    insert_sequent_backend_election_event: IPermissions.ELECTION_EVENT_CREATE,
    insert_sequent_backend_election_events: IPermissions.ELECTION_EVENT_CREATE,
    update_sequent_backend_election_event: IPermissions.ELECTION_EVENT_WRITE,
    update_sequent_backend_election_events: IPermissions.ELECTION_EVENT_WRITE,
    delete_sequent_backend_election_event: IPermissions.ELECTION_EVENT_DELETE,
    delete_sequent_backend_election_events: IPermissions.ELECTION_EVENT_DELETE,
    // keys_ceremony
    sequent_backend_keys_ceremony: IPermissions.ADMIN_CEREMONY,
    sequent_backend_keys_ceremonys: IPermissions.ADMIN_CEREMONY,
    // results_area_contest
    sequent_backend_results_area_contest: IPermissions.TALLY_RESULTS_READ,
    sequent_backend_results_area_contests: IPermissions.TALLY_RESULTS_READ,
    // results_area_contest_candidate
    sequent_backend_results_area_contest_candidate: IPermissions.TALLY_RESULTS_READ,
    sequent_backend_results_area_contest_candidates: IPermissions.TALLY_RESULTS_READ,
    // results_contest
    sequent_backend_results_contest: IPermissions.TALLY_RESULTS_READ,
    sequent_backend_results_contests: IPermissions.TALLY_RESULTS_READ,
    // results_contest_candidate
    sequent_backend_results_contest_candidate: IPermissions.TALLY_RESULTS_READ,
    sequent_backend_results_contest_candidates: IPermissions.TALLY_RESULTS_READ,
    // results_election
    sequent_backend_results_election: IPermissions.TALLY_RESULTS_READ,
    sequent_backend_results_elections: IPermissions.TALLY_RESULTS_READ,
    // results_election
    sequent_backend_results_election_area: IPermissions.TALLY_RESULTS_READ,
    sequent_backend_results_election_areas: IPermissions.TALLY_RESULTS_READ,
    // results_event
    sequent_backend_results_event: IPermissions.TALLY_RESULTS_READ,
    sequent_backend_results_events: IPermissions.TALLY_RESULTS_READ,
    // support_material
    sequent_backend_support_material: IPermissions.SUPPORT_MATERIAL_READ,
    sequent_backend_support_materials: IPermissions.SUPPORT_MATERIAL_READ,
    insert_sequent_backend_support_material: IPermissions.SUPPORT_MATERIAL_WRITE,
    insert_sequent_backend_support_materials: IPermissions.SUPPORT_MATERIAL_WRITE,
    update_sequent_backend_support_material: IPermissions.SUPPORT_MATERIAL_WRITE,
    update_sequent_backend_support_materials: IPermissions.SUPPORT_MATERIAL_WRITE,
    delete_sequent_backend_support_material: IPermissions.SUPPORT_MATERIAL_WRITE,
    delete_sequent_backend_support_materials: IPermissions.SUPPORT_MATERIAL_WRITE,
    // tally_session
    sequent_backend_tally_session: IPermissions.ADMIN_CEREMONY,
    sequent_backend_tally_sessions: IPermissions.ADMIN_CEREMONY,
    // tally_session_contest
    sequent_backend_tally_session_contest: IPermissions.ADMIN_CEREMONY,
    sequent_backend_tally_session_contests: IPermissions.ADMIN_CEREMONY,
    // tally_session_execution
    sequent_backend_tally_session_execution: IPermissions.ADMIN_CEREMONY,
    sequent_backend_tally_session_executions: IPermissions.ADMIN_CEREMONY,
    // tally_session_resolution
    sequent_backend_tally_session_resolution: IPermissions.TALLY_RESOLUTION_SUBMIT,
    sequent_backend_tally_session_resolutions: IPermissions.TALLY_RESOLUTION_SUBMIT,
    // tally_sheet
    sequent_backend_tally_sheet: IPermissions.TALLY_SHEET_VIEW,
    sequent_backend_tally_sheets: IPermissions.TALLY_SHEET_VIEW,
    insert_sequent_backend_tally_sheet: IPermissions.TALLY_SHEET_CREATE,
    insert_sequent_backend_tally_sheets: IPermissions.TALLY_SHEET_CREATE,
    update_sequent_backend_tally_sheet: IPermissions.TALLY_SHEET_CREATE,
    update_sequent_backend_tally_sheets: IPermissions.TALLY_SHEET_CREATE,
    delete_sequent_backend_tally_sheet: IPermissions.TALLY_SHEET_CREATE,
    delete_sequent_backend_tally_sheets: IPermissions.TALLY_SHEET_CREATE,
    // trustee
    sequent_backend_trustee: IPermissions.TRUSTEE_READ,
    sequent_backend_trustees: IPermissions.TRUSTEE_READ,
    insert_sequent_backend_trustee: IPermissions.TRUSTEE_WRITE,
    insert_sequent_backend_trustees: IPermissions.TRUSTEE_WRITE,
    update_sequent_backend_trustee: IPermissions.TRUSTEE_WRITE,
    update_sequent_backend_trustees: IPermissions.TRUSTEE_WRITE,
    delete_sequent_backend_trustee: IPermissions.TRUSTEE_WRITE,
    delete_sequent_backend_trustees: IPermissions.TRUSTEE_WRITE,
    //preview
    sequent_backend_preview: IPermissions.PREVIEW_READ,
    sequent_backend_previews: IPermissions.PREVIEW_READ,
    // voter secret attributes
    RevealVoterSecretAttribute: IPermissions.VOTER_READ,
    // ballot box seals (VOTE-FREEZE), with their area's name: the election's
    // Dashboard; the tally list asks with tally-read itself.
    GetBallotBoxSeals: IPermissions.ELECTION_DASHBOARD_TAB,
    GetEventBallotBoxSeals: IPermissions.ELECTION_DASHBOARD_TAB,
    GetFailedBallotBoxSeals: IPermissions.ELECTION_DASHBOARD_TAB,
    // the areas the card lists as Open before the close: their ballot styles and names
    GetBallotBoxAreas: IPermissions.ELECTION_DASHBOARD_TAB,
    GetBallotBoxAreaNames: IPermissions.ELECTION_DASHBOARD_TAB,
    // monitoring actions: Harvest checks the permission and labels again
    MonitoringListDashboards: IPermissions.MONITORING_VIEW,
    MonitoringGetDashboard: IPermissions.MONITORING_VIEW,
    MonitoringRenderWidget: IPermissions.MONITORING_VIEW,
    MonitoringExport: IPermissions.MONITORING_VIEW,
    MonitoringValidateConfig: IPermissions.MONITORING_CONFIGURE,
    MonitoringSaveConfig: IPermissions.MONITORING_CONFIGURE,
    MonitoringResetToPreset: IPermissions.MONITORING_CONFIGURE,
    MonitoringListPresets: IPermissions.MONITORING_CONFIGURE,
    MonitoringSetMode: IPermissions.MONITORING_CONFIGURE,
    MonitoringListConfig: IPermissions.MONITORING_CONFIGURE,
    MonitoringGetConfig: IPermissions.MONITORING_CONFIGURE,
    // approval matrix actions: Harvest checks the permission again
    GetApprovalMatrix: IPermissions.APPLICATION_READ,
    EvaluateApprovalMatrix: IPermissions.APPLICATION_READ,
    SaveApprovalMatrix: IPermissions.APPROVAL_MATRIX_WRITE,
    // messaging: the default role reads none of it; every call site also
    // names its role, and Harvest checks the permission again for actions
    GetEventMessagingConfig: IPermissions.MESSAGING_CONFIG_READ,
    GetEventMessagingConfigAuthor: IPermissions.MESSAGING_CONFIG_READ,
    GetMessagingAccountSummaries: IPermissions.MESSAGING_CONFIG_READ,
    GetVoterUnsettledMessages: IPermissions.MESSAGING_CONFIG_READ,
    GetVoterMessageAttempts: IPermissions.MESSAGING_CONFIG_READ,
    GetLedgerMessageStates: IPermissions.MESSAGING_CONFIG_READ,
    GetMessagingEventStats: IPermissions.MESSAGING_CONFIG_READ,
    GetMessagingCallbackStatus: IPermissions.MESSAGING_CONFIG_READ,
    UpdateEventMessagingConfig: IPermissions.MESSAGING_CONFIG_WRITE,
    GetMessagingAccounts: IPermissions.MESSAGING_ACCOUNT_READ,
    MessagingAccountCallbackUrl: IPermissions.MESSAGING_ACCOUNT_WRITE,
    UpsertMessagingAccount: IPermissions.MESSAGING_ACCOUNT_WRITE,
    CheckMessagingAccount: IPermissions.MESSAGING_ACCOUNT_WRITE,
    ReplaceMessagingAccountCredentials: IPermissions.MESSAGING_ACCOUNT_WRITE,
    DeleteMessagingAccount: IPermissions.MESSAGING_ACCOUNT_WRITE,
    TestMessagingAccount: IPermissions.MESSAGING_ACCOUNT_WRITE,
    GetMessagingAudiencePreview: IPermissions.MESSAGING_CONFIG_READ,
    GetMessagingVoterCounts: IPermissions.MESSAGING_CONFIG_READ,
    RecountMessagingVoters: IPermissions.MESSAGING_CONFIG_READ,
    // also granted to messaging-config-read; the call site picks the role
    GetMessagingMonthlyVolumes: IPermissions.MESSAGING_ACCOUNT_READ,
    MessagingAccountChangeImpact: IPermissions.MESSAGING_ACCOUNT_WRITE,
    MessagingFakeProviderMessages: IPermissions.MESSAGING_ACCOUNT_WRITE,
    MessagingFakeProviderMessage: IPermissions.MESSAGING_ACCOUNT_WRITE,
    MessagingFakeProviderGetStarted: IPermissions.MESSAGING_ACCOUNT_WRITE,
    // Approvals: look an application up by its support reference
    FindApplicationsBySupportReference: IPermissions.APPLICATION_READ,
};
var TrusteeOperationMap = __assign(__assign({}, AdminOperationMap), { 
    // keys_ceremony
    sequent_backend_keys_ceremony: IPermissions.TRUSTEE_CEREMONY, sequent_backend_keys_ceremonys: IPermissions.TRUSTEE_CEREMONY, 
    // tally_session
    sequent_backend_tally_session: IPermissions.TRUSTEE_CEREMONY, sequent_backend_tally_sessions: IPermissions.TRUSTEE_CEREMONY, 
    // tally_session_contest
    sequent_backend_tally_session_contest: IPermissions.TRUSTEE_CEREMONY, sequent_backend_tally_session_contests: IPermissions.TRUSTEE_CEREMONY, 
    // tally_session_execution
    sequent_backend_tally_session_execution: IPermissions.TRUSTEE_CEREMONY, sequent_backend_tally_session_executions: IPermissions.TRUSTEE_CEREMONY, getUsers: IPermissions.VOTER_READ, 
    // Whether the trustee's key step needs their signature
    CustodyProofSignatureStatus: IPermissions.TRUSTEE_CEREMONY });
/**
 * Staff without the `admin-user` Hasura role (the Signatures tab's own groups) query with
 * the fine-grained role of each operation, and with read-only `election-event-read` for
 * the rest: navigating to an event, the sidebar tree and the tenant. Hasura grants that
 * role no writes, so an operation it can't serve fails instead of borrowing `admin-user`.
 */
var NonAdminOperationMap = __assign(__assign({}, AdminOperationMap), { sequent_backend_tenant: IPermissions.ELECTION_EVENT_READ, election_events_tree: IPermissions.ELECTION_EVENT_READ, election_tree: IPermissions.ELECTION_EVENT_READ, contest_tree: IPermissions.ELECTION_EVENT_READ, candidate_tree: IPermissions.ELECTION_EVENT_READ, 
    // Users and Roles: Harvest checks the permission again
    getRoles: IPermissions.ROLE_READ, getPermissions: IPermissions.USER_PERMISSION_READ, SetRolePermission: IPermissions.ROLE_WRITE, DeleteRolePermission: IPermissions.ROLE_WRITE, getUsers: IPermissions.USER_READ, 
    // Post > Publish: Start and Stop voting, and Initialize voting (its report)
    UpdateElectionVotingStatus: IPermissions.ELECTION_STATE_WRITE, CreateTallyCeremony: IPermissions.ADMIN_CEREMONY });
// Roles that operations without a mapped role run as, in order of preference
var DEFAULT_OPERATION_ROLES = [
    IPermissions.ADMIN_USER,
    IPermissions.TRUSTEE_CEREMONY,
    IPermissions.PUBLISH_READ,
];
var mappedRoleOf = function (operationMap, operationName) {
    return operationName && Object.prototype.hasOwnProperty.call(operationMap, operationName)
        ? operationMap[operationName]
        : undefined;
};
export var getOperationRole = function (operation, hasRole) {
    var _a;
    var operationName = operation === null || operation === void 0 ? void 0 : operation.operationName;
    if (operationName === "BallotPrivacySettings")
        return IPermissions.ELECTION_EVENT_READ;
    if (operationName === "ForensicNetworkSummary" || operationName === "ForensicNetworkDetail") {
        return IPermissions.FORENSIC_READ;
    }
    if (operationName === "BallotBoxEntry" || operationName === "BallotBoxKeys") {
        return IPermissions.LOGS_READ;
    }
    var defaultRole = DEFAULT_OPERATION_ROLES.find(hasRole);
    if (!defaultRole) {
        var role = (_a = mappedRoleOf(NonAdminOperationMap, operationName)) !== null && _a !== void 0 ? _a : IPermissions.ELECTION_EVENT_READ;
        // An auditor may hold only the tenant log's permissions: the schema is then
        // read, and everything else refused, as the role that reads that log.
        return hasRole(role) || !hasRole(IPermissions.TENANT_LOGS_READ)
            ? role
            : IPermissions.TENANT_LOGS_READ;
    }
    var operationMap = hasRole(IPermissions.TRUSTEE_CEREMONY)
        ? TrusteeOperationMap
        : AdminOperationMap;
    var mappedRole = mappedRoleOf(operationMap, operationName);
    if (!mappedRole) {
        return defaultRole;
    }
    return defaultRole === IPermissions.ADMIN_USER || hasRole(mappedRole) ? mappedRole : defaultRole;
};
